// extracted by mini-css-extract-plugin
export default {"radio":"Accordion_radio__s5Gcm"};